import { pick } from 'lodash'
import { page, track } from '../analytics'

const getArgs = args => {
  return pick(args, ['workspaceId', 'workspaceSlug'])
}

export const personasExplorerViewed = args => {
  page('Personas Explorer Viewed', getArgs(args))
}

export const personasExplorerSearched = args => {
  track('Personas Explorer Searched', {
    ...getArgs(args),
    searchString: args.searchString,
    matchFound: args.matchFound
  })
}
